import { render, staticRenderFns } from "./shopShare.vue?vue&type=template&id=607e3e2c&scoped=true&"
import script from "./shopShare.vue?vue&type=script&lang=js&"
export * from "./shopShare.vue?vue&type=script&lang=js&"
import style0 from "./shopShare.vue?vue&type=style&index=0&id=607e3e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607e3e2c",
  null
  
)

export default component.exports